<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="관리부서"
      :tableData="[
        { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
        { id: 'input2', title: '소속(부서명)', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '담당업무',
          type: 'select',
          selectData: [
            '시설 안전조치',
            '유지보수 업무',
            '기타 안전관리',
          ],
          placeholder: '선택',
        },
        { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.companyList1"
    />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="수탁업체"
      :tableData="[
        { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
        { id: 'input2', title: '업체명', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '담당업무',
          type: 'select',
          selectData: [
            '시설 안전조치',
            '유지보수 업무',
            '기타 안전관리',
          ],
          placeholder: '선택',
        },
        { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.companyList2"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        companyList1: [],
        companyList2: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
